import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function Problem() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-lighter px-4 py-16 md:py-24" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-119">
          <h2 className="font-bebas text-4xl md:text-6xl lg:text-7xl text-white leading-tight border-l-4 border-teal pl-6" data-id="element-120">
            TU CEREBRO NO ESTÁ ROTO, ESTÁ SECUESTRADO
          </h2>

          <div className="space-y-6 text-base md:text-lg leading-relaxed" data-id="element-121">
            <p className="font-inter text-text/90" data-id="element-122">
              No es falta de disciplina. Tu cerebro no está roto, está
              secuestrado.
            </p>

            <p className="font-inter text-text/80" data-id="element-123">
              Las empresas de tecnología han hackeado tu química cerebral. Has
              sido bombardeado por tanta dopamina sintética (redes, pornografía,
              azúcar, entretenimiento vacío) que tus receptores se han "apagado"
              para protegerse.
            </p>

            <p className="font-inter text-text/80" data-id="element-124">
              Por eso, tareas que antes eran emocionantes (leer un libro,
              trabajar en tu proyecto, entrenar) ahora te parecen aburridas o
              imposibles de mantener. Estás viviendo como un espectador en tu
              propia vida, sedado por una pantalla.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}